import React from 'react'
import Slider from 'react-slick'
import { Card, Button } from 'semantic-ui-react'
import ButtonAction from './Button'
import arrow_right from '../../img/send-message-btn-mobile.png'
import arrow_left from '../../img/send-message-btn-mobile-left.png'

const slidesToShowMobile = 1;
const slidesToShowDesktop = 2;
const responsiveStep = 1000;

function SampleNextArrow(props) {
  const { className, style, onClick } = props
  return (
    <div
      className={className}
      style={{
        ...style,
        display: 'block',
        zIndex: '10',
        right: '0',
        backgroundImage: `url(${arrow_right})`
      }}
      onClick={onClick}
    />
  )
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props
  return (
    <div
      className={className}
      style={{
        ...style,
        display: 'block',
        zIndex: '10',
        left: '0',
        backgroundImage: `url(${arrow_left})`
      }}
      onClick={onClick}
    />
  )
}


function computeButtons(buttons) {
  return (
    <Button.Group fluid>
      {
        buttons.map((button, i) => (
          <ButtonAction
            button={button}
            key={i}
          />
        ),
        )
      }
    </Button.Group>
  )
}


class CarouselFilters extends React.Component {
  constructor() {
    super()
    this.state = {
      isSlideNumber: 0
    }
  }


  render() {

    const {
      numberOfSlides,
      slidesToShow
    } = this.props;

    const { isSlideNumber } = this.state;

    return (
      <div
        style={{
          width: '100%',
          height: '100%'
        }}
      >
        <div
          className="carrousel-filter"
          style={{
            background: 'linear-gradient(to right, rgba(255,255,255,0), rgba(255,255,255,0) 75%, rgba(255,255,255,1))',
            opacity: (isSlideNumber === 0 && numberOfSlides > slidesToShow) ? 1 : 0
          }}
        />
        <div
          className="carrousel-filter"
          style={{
            background: 'rgba(255,255,255,0)',
            opacity: (isSlideNumber === 0 && numberOfSlides <= slidesToShow) ? 1 : 0
          }}
        />
        <div
          className="carrousel-filter"
          style={{
            background: 'linear-gradient(to left, rgba(255,255,255,0), rgba(255,255,255,0) 75%, rgba(255,255,255,1))',
            opacity: (isSlideNumber === numberOfSlides - slidesToShow) ? 1 : 0,
          }}
        />
        <div
          className="carrousel-filter"
          style={{
            background: 'linear-gradient(to right, rgba(255,255,255,1), rgba(255,255,255,0) 25%, rgba(255,255,255,0) 75%, rgba(255,255,255,1))',
            opacity: (isSlideNumber !== 0 && isSlideNumber !== numberOfSlides - slidesToShow) ? 1 : 0
          }}
        />
      </div>
    )
  }
}


class Carousel extends React.Component {

  constructor() {
    super();
    this.beforeChange = this.beforeChange.bind(this);
  }
  componentDidMount() {
    this.slideNumber = 0;
    if (this.bilan && this.props.last) {
        const prevContainerChat = this.bilan.parentElement.parentElement.previousSibling;
        const secondRow = prevContainerChat.parentElement.parentElement;
        window.setTimeout(() => {
          secondRow.scrollTop = prevContainerChat.offsetTop + prevContainerChat.offsetHeight - secondRow.offsetTop;
        }, 0);
    } else {
      return;
    }
  }


  beforeChange(oldIndex, newIndex) {
    this.filter.setState({
      isSlideNumber: newIndex
    })
  }

  render() {

    const message = this.props.message;

    const settings = {
      speed: 500,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
      infinite: false,
      arrows: true,
      slidesToScroll: 1,
      // useCSS: true,
      variableWidth: true,
      responsive: [
      {
        breakpoint: responsiveStep,
        settings: {
          slidesToShow: slidesToShowMobile,
        }
      },
      {
        breakpoint: 1000000,
        settings: {
          slidesToShow: slidesToShowDesktop,
        },
      }]
    }
    const attachmentsToShow = message.attachments.filter(attachment => !Number.isInteger(parseInt(attachment.content.images[0].url, 10)));
    const numberOfSlides = attachmentsToShow.length;
    return (
      <div style={{ height: '100%', width: '100%'}}>
        <Slider
        className={`real-carrousel`}
        beforeChange={this.beforeChange}
        {...settings}
        >
        {attachmentsToShow
          .map((attachment, i) => (
              <div
              key={i}
              style={{ margin: '10px', height: '100%' }}>
                <Card
                  className={`${attachment.content.images[0].url && 'carrousel-images'}`}
                  image={(attachment.content.images[0].url) && attachment.content.images[0].url}
                  extra={attachment.content.buttons && computeButtons(attachment.content.buttons)}/>
              </div>
            ))}
        </Slider>
        <CarouselFilters
          numberOfSlides={numberOfSlides}
          slidesToShow={window.innerWidth < responsiveStep ? slidesToShowMobile : slidesToShowDesktop}
          ref={filter => this.filter = filter}
        />
      </div>
    )
  }
}



export default Carousel



// WEBPACK FOOTER //
// ./src/views/components/Carousel.js